import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error:any = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <h1>Oops! Nope.</h1>
      <p>Sorry, an unexpected error has occurred. My best guess is that you tried something funky :-)</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}